import ActivesPageLayout from 'presentation/layout/modules/actives/ActivesPageLayout';
import { FC } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { Center, Spinner } from '@chakra-ui/react';
import { useFetchStrategyDetailQuery } from 'rtkQuery/sharespro/queries/strategies';
import StrategyDetailLoaded from 'presentation/components/modules/strategies/detail/StrategyDetailLoaded';
import ErrorContainer from 'presentation/components/shared/ErrorContainer';
import AppCard from 'presentation/components/shared/card/AppCard';
import StrategyApplyCard from 'presentation/components/modules/strategies/detail/StrategyApplyCard';
import { useUpdateEffect } from 'react-use';

const StrategyDetailPage: FC = () => {
  const { t, i18n } = useTranslation();

  const { id } = useParams();

  const parsedId = +(id as string);

  const { data, error, refetch, isFetching } =
    useFetchStrategyDetailQuery(parsedId);

    useUpdateEffect(() => {
      refetch();
    }, [i18n.language]);

  let content;
  let hasData = false;
  if (data) {
    content = <StrategyDetailLoaded data={data} id={parsedId} />;
    hasData = true;
  } else if (isFetching) {
    content = <Spinner />;
  } else if (error) {
    content = (
      <ErrorContainer
        error={error}
        onRetry={() => {
          refetch();
        }}
      />
    );
  } else {
    content = <Spinner />;
  }

  if (!hasData) {
    content = (
      <AppCard p="20px">
        <Center>{content}</Center>
      </AppCard>
    );
  }

  return (
    <ActivesPageLayout
      sidebarContent={
        data && (
          <StrategyApplyCard
            name={data.intro.title}
            id={parsedId}
            currency={data.currency}
            amount={data.entryAmount}
          />
        )
      }
    >
      <Helmet>
        <title>{t('strategiesTitle')}</title>
      </Helmet>
      {content}
    </ActivesPageLayout>
  );
};

export default StrategyDetailPage;
